import { Layout } from 'antd';
import styled, { css } from 'styled-components';

const { Sider } = Layout;

export const SidebarStyled = styled(Sider)`
    background: white;
    z-index: 99;
    top: 62px;
    height: 100%;
    ${({ $isMobile }) =>
        $isMobile
            ? css`
                  position: absolute;
              `
            : css`
                  position: sticky;
              `}
    box-shadow: 0px 5px 8px rgba(168, 216, 243, 0.5);
    ${({ collapsed, $isMobile }) =>
        collapsed &&
        $isMobile &&
        css`
            visibility: hidden;
            width: 0px !important;
            max-width: 0px !important;
            min-width: 0px !important;
        `}
    #em-menus {
        height: 100%;
        .ant-menu {
            height: 100%;
        }
        .ant-space {
            .ant-space-item {
                display: flex;
                align-items: center;
            }
        }
    }
`;
